'use strict';

class UniteBasketItem {

    constructor(basketItemId) {
        this.eprocBasketItemId = basketItemId;

        this._setAccount();
        this._setCostCenter();
        this._setProject();
        this._setCustomAccountAssignment();
        this._setClassification();
    }

    setUniteArticleId(value) {
        this.uniteArticleId = value;
    }

    setQuantityOld(oldQuantityHid) {
        let oldQuantity = document.getElementById(oldQuantityHid);
        this.quantityOld = !oldQuantity ? null : +oldQuantity.value;
    }

    setQuantityNew(newQuantityHid, tabName) {
        // check if the item is marked for deletion. If so we want to set the new value to 0 to delete this item.
        if (UniteBasketItem.isUniteProduct(tabName)) {
            const deleteItemFieldName = this.eprocBasketItemId + '_VS_DROP_ITEM';
            const dropItem = document.getElementsByName(deleteItemFieldName)[0].getAttribute("aria-checked");
            if (dropItem === "true") {
                return this.quantityNew = 0;
            }
        }

        // the item is not marked for deletion. We can now proceed to extract the quantity from the input
        let newQuantity = document.getElementById(newQuantityHid);
        this.quantityNew = !newQuantity ? null : +newQuantity.value;
    }

    _setProject() {
        const projectFieldName = this.eprocBasketItemId + '_VS_CUST_PROJ';
        let project = document.getElementsByName(projectFieldName)[0];
        this.project = !project ? '' : project.value;
    }

    _setAccount() {
        const accountFieldName = this.eprocBasketItemId + '_VS_CUST_ACC';
        let account = document.getElementsByName(accountFieldName)[0];
        this.account = !account ? '' : account.value;
    }

    _setCostCenter() {
        const costCenterFieldName = this.eprocBasketItemId + '_VS_CUST_KST';
        let costCenter = document.getElementsByName(costCenterFieldName)[0];
        this.costCenter = !costCenter ? '' : costCenter.value;
    }

    _setClassification() {
        const classificationIdFieldName = this.eprocBasketItemId + '_VS_CLASSIFY_ID';
        let classificationId = document.getElementsByName(classificationIdFieldName)[0];
        this.classificationId = !classificationId ? null : classificationId.value;
        const classificationNumberFieldName = 'VS_CLASSIFY_NO_' + this.eprocBasketItemId;
        let classificationNumber = document.getElementsByName(classificationNumberFieldName)[0];
        this.classificationNumber =
            classificationNumber && classificationNumber.value !== '' ?
                classificationNumber.value :
                null;
    }

    setCustomerArticleNumber(tabName, feeGrpId) {
        const self = this;
        const setArtno = (customerArticleNumberFieldName) => {
            let customerArticleNumber = document.getElementsByName(customerArticleNumberFieldName)[0];
            self.customerArticleNumber = !customerArticleNumber ? '' : customerArticleNumber.value;
        }
        if(UniteBasketItem.isUniteProduct(tabName)) {
            const customerArticleNumberFieldName = this.eprocBasketItemId + '_VS_KD_ARTNO';
            setArtno(customerArticleNumberFieldName);
        } else if(UniteBasketItem.isUniteShipping(tabName)){
            const customerArticleNumberFieldName = `VS_KD_ARTNO_VS_FRIGHT_SURCHARGE_${feeGrpId}`;
            setArtno(customerArticleNumberFieldName);
        }
    }

    _setCustomAccountAssignment() {
        const customAccountAssignmentEntries = [];

        const customAccountAssignmentInputPrefix = `${this.eprocBasketItemId}_accountAssignmentType:`;
        const customAccountAssignmentInputs =
            document.querySelectorAll(`[name^='${customAccountAssignmentInputPrefix}']`);

        try {
            if (customAccountAssignmentInputs && customAccountAssignmentInputs.length > 0) {
                for (const input of customAccountAssignmentInputs) {
                    const typeId = input.name
                        .replace(`${customAccountAssignmentInputPrefix}`, '');
                    if (!isNaN(+typeId)) {
                        const keyInput = document.querySelectorAll(`[name^="${this.eprocBasketItemId}_accountAssignmentCode:${typeId}"]`)[0];
                        const nameInput = document.querySelectorAll(`[name^="${this.eprocBasketItemId}_accountAssignmentName:${typeId}"]`)[0];

                        if (keyInput) {
                            const customAccountAssignmentEntry = {
                                typeId: +typeId,
                                code: keyInput.value,
                                name: nameInput.value
                            };
                            customAccountAssignmentEntries.push(customAccountAssignmentEntry);
                        }
                    }
                }
            }
        } catch (e) {
            console.error(e)
        }
        this.customAccountAssignment = customAccountAssignmentEntries;
    }

    static isUniteProduct(tabName) {
        return tabName === 'UNITE'
    }

    static isUniteShipping(tabName) {
        return tabName === 'UNITE_FREIGHT'
    }
}

module.exports = UniteBasketItem;
